import * as S from "../Style/Page/Fork.style.js";
import LeftImg from "../assets/logo/forkliftbusiness.png";
const HatPageTopLine = (props) => {
  return (
    <S.PageTopLine>
      <div className="page-top-line-left">
        <img src={LeftImg} alt="" />
      </div>
      <div className="page-top-line-title">
        {" "}
        <div class="kor">{props.titleko}</div>
        <div class="eng">{props.titleeng}</div>
      </div>
      <div className="page-top-line-right"></div>
    </S.PageTopLine>
  );
};

export default HatPageTopLine;
